import type { ICreateSupraSubscriptionBody } from '@/app-package';
import axios from 'axios';

const createSupraSystemSubscription = async (
  body: ICreateSupraSubscriptionBody,
) => {
  await axios.post('/supra_system/subscription/create', body);
};

export default createSupraSystemSubscription;
